import {
  IPageChangeStartedAction,
  FILTERS_PAGINATION_PAGE_CHANGE_STARTED,
  IPageChangeFinishedAction,
  FILTERS_PAGINATION_PAGE_CHANGE_FINISHED,
} from './types';
import { IOffersData } from 'shared/types/offersData';

export const pageChangeStarted = (): IPageChangeStartedAction => ({
  type: FILTERS_PAGINATION_PAGE_CHANGE_STARTED,
});

export const pageChangeFinished = (data: IOffersData, paginationUrls: string[]): IPageChangeFinishedAction => ({
  type: FILTERS_PAGINATION_PAGE_CHANGE_FINISHED,
  data,
  paginationUrls,
});
